<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-08-08 14:29:13
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-08 15:23:59
 * @FilePath: \member_ship\src\views\Contacts.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="Contactsbody">
    <div class="addMemPage">
        加入组织
    </div>
    <div class="headerBox">会员通讯录</div>
    <div class="searchBox">
      <van-search v-model="keyWord" show-action placeholder="请输入搜索关键词">
        <template #action>
          <div>搜索</div>
        </template>
      </van-search>
    </div>
    <div class="myMainbox">
      <div class="myMainitem" v-for="item in lsitData" @click="showMoreData(item)">
        <div class="usrImgBox">
          <img src="../assets/1668419337598639.jpg" alt />
        </div>
        <div class="itemLfetBox">
          <div class="useName">
            {{item.member_name}}
            <van-tag style="margin-left:5px" color="#FFCF66" text-color="black" type="primary">{{item.member_level}}</van-tag>
          </div>
          <div class="tagList">
            <van-tag  plain  type="primary">{{item.member_label}}</van-tag>
            <van-tag style="margin-left:5px" type="primary" plain>{{item.member_qycontent}}</van-tag>
          </div>
          <div class="comDataText">
            {{item.member_com}}
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="show" title="详细信息" show-cancel-button>
  <div class="popBox">
    <div class="mytextBox">
        <div class="mytextLeft">姓名：</div>
        <div class="mytextRight">{{chooseData.member_name}}</div>
    </div>
    <div class="mytextBox">
        <div class="mytextLeft">联系方式：</div>
        <div class="mytextRight">{{chooseData.member_phone}}</div>
    </div>
    <div class="mytextBox">
        <div class="mytextLeft">所属组织：</div>
        <div class="mytextRight">{{chooseData.member_com}}</div>
    </div>
    <div class="mytextBox">
        <div class="mytextLeft">联系地址：</div>
        <div class="mytextRight">{{chooseData.member_address}}</div>
    </div>
    <div class="mytextBox">
        <div class="mytextLeft">职位：</div>
        <div class="mytextRight">{{chooseData.member_qycontent}}</div>
    </div>
  </div>
</van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
        show:false,
      keyWord: "",
      lsitData:[],
      chooseData:{}
    };
  },
  created(){
    this.getData()
  },
  methods:{
    showMoreData(data){
        this.show= true
        console.log(data);
        this.chooseData = data
    },
    getData(){
         this.$axios({
        method: "post",
        url: `https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getSanMingMemberData` // 接口地址
      }).then((res)=>{
        console.log(res.data.dataList);
        this.lsitData=res.data.dataList
      })
    }
  }
};
</script>

<style>
.headerBox {
  height: 50px;
  text-align: center;
  line-height: 50px;
  /* line-height: 50px; */
  /* background-color: #06bbe2; */
  background-image: url("../assets/OIP-C.jpg");
  color: white;
}
.myMainbox {
  height: calc(100vh - 100px);
  width: 100%;
  background-color: #f7f8fc;
  padding: 20px;
}
.searchBox {
  height: 50px;
  width: 100%;
  /* background-color: red; */
}
.myMainitem {
  height: 110px;
  width: 100%;
  /* background-color: red; */
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.usrImgBox {
  width: 100px;
  height: 100px;
  /* background-color: aqua; */
}
.usrImgBox img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: hidden;
}
.itemLfetBox {
  height: 100px;
  width: calc(100% - 100px);
  padding-left: 15px;
  /* background-color: red; */
}
.useName {
  height: 30px;
  width: 100%;
  font-size: 16px;
}
.tagList {
  height: 30px;
  width: 100%;
}
.comDataText{
    height: 40px;
    width: 100%;
    /* background-color: red; */
    color: #9B9EBB;
    line-height: 40px;
    font-size: 14px;
}
.addMemPage{
  height: 70px;
  width: 70px;
  border-radius: 50%;
  position: absolute;
  right: 20px;
  bottom: 100px;
  background-color:#209CF1;
  line-height: 70px;
  text-align: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
 
}
.popBox{
    width: 80vw;
    height: 300px;
}
.mytextBox{
    width: 100%;
    height: 30px;
    display: flex;
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 15px;
}

.mytextLeft{
    width: 30%;
}
.mytextRight{
    width: 70%;
    /* background-color: #209CF1; */
}
</style>